<template>
    <span>
        <button v-if="!entrada.deleted_at" @click="showModal('edit-' + entrada.id)" class="button small-button ml-2">{{ $t('perfil.cambiar_datos') }}</button>
        <template v-if="entrada.fecha_limite_cambiar_datos">
            <div class="mt-2">
                <p>{{ $t('perfil.limite_cambiar_datos', { fecha_fin_evento: this.entrada.fecha_limite_cambiar_datos.nombre }) }}</p>
            </div>
        </template>
        <EditTicketModal :entrada="entrada" @close="closeModal"/>
    </span>
</template>

<script>
    import EditTicketModal from './EditTicketModal'

    export default {
        props: ['entrada', 'esMovil', 'left', 'top'],
        methods: {
            showModal() {
                this.$emit('show', 'edit-' + this.entrada.id)
            },
            closeModal() {
                this.$emit('close', 'edit-' + this.entrada.id);
            }
        },
        components: { EditTicketModal }
    }
</script>